import React, { useState, useEffect } from 'react';
import { storage, auth } from '../../lib/firebase';
import { ref, getDownloadURL } from 'firebase/storage';
import { DesktopService } from '../../services/desktopService';

const CloseIcon = ({ className }) => <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>;
const Spinner = () => <svg className="animate-spin h-8 w-8 text-indigo-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>;

const LiveStreamModal = ({ open, onClose, targetDeviceId, targetUid }) => {
    const [displaySrc, setDisplaySrc] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!open || !targetUid || !targetDeviceId) return;

        const startStream = async () => {
            try {
                await DesktopService.sendDesktopCommand(targetUid, targetDeviceId, { command: 'start_stream' });
            } catch (err) {
                console.error(err);
                setError("Failed to start stream.");
            }
        };

        startStream();

        return () => {
            if (targetUid && targetDeviceId) {
                DesktopService.sendDesktopCommand(targetUid, targetDeviceId, { command: 'stop_stream' }).catch(console.error);
            }
        };
    }, [open, targetUid, targetDeviceId]);

    useEffect(() => {
        if (!open || !targetUid || !targetDeviceId) return;

        // Path should match the one used by desktop python agent
        const path = `stream/${targetUid}/${targetDeviceId}/latest.jpg`;
        const storageRef = ref(storage, path);

        const refreshFrame = async () => {
            try {
                const url = await getDownloadURL(storageRef);
                const separator = url.includes('?') ? '&' : '?';
                setDisplaySrc(`${url}${separator}t=${Date.now()}`);
            } catch (err) {
                console.warn("Refresh failed:", err.message);
            }
        };

        refreshFrame();
        const interval = setInterval(refreshFrame, 2000); // 2 seconds

        return () => clearInterval(interval);
    }, [open]);

    if (!open) return null;

    return (
        <div className="fixed inset-0 z-[100] bg-black flex flex-col items-center justify-center">
            {/* Close Button */}
            <button
                onClick={onClose}
                className="absolute top-4 right-4 p-2 bg-white/10 hover:bg-white/20 text-white rounded-full transition-colors z-[110] focus:outline-none"
            >
                <CloseIcon className="w-6 h-6" />
            </button>

            {/* Content */}
            {error ? (
                <div className="text-red-500 font-bold p-4 bg-red-500/10 rounded-xl">{error}</div>
            ) : displaySrc ? (
                <img
                    src={displaySrc}
                    alt="Live Desktop"
                    className="max-w-full max-h-full object-contain"
                />
            ) : (
                <div className="flex flex-col items-center justify-center gap-4">
                    <Spinner />
                    <p className="text-white text-sm font-medium tracking-wide animate-pulse">Connecting to Desktop...</p>
                </div>
            )}

            {/* Status Indicator */}
            {displaySrc && (
                <div className="absolute bottom-6 left-6 flex items-center gap-2 bg-black/50 px-3 py-1.5 rounded-full backdrop-blur-sm border border-white/10">
                    <div className="w-2.5 h-2.5 rounded-full bg-red-500 shadow-[0_0_8px_rgba(239,68,68,0.8)] animate-pulse" />
                    <span className="text-xs font-bold text-white tracking-widest opacity-90">LIVE <span className="text-slate-400 font-medium ml-1 flex-shrink-0 relative hidden sm:inline">(2s Refresh)</span></span>
                </div>
            )}
        </div>
    );
};

export default LiveStreamModal;
